import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { CorVeiculoService } from '../services/cor-veiculo.service';
import { EspecialidadeVeiculoService } from '../services/especialidade-veiculo.service';
import { MarcaVeiculoService } from '../services/marca-veiculo.service';
import { ModeloVeiculoService } from '../services/modelo-veiculo.service';
import { MotivoIndisponibilidadeService } from '../services/motivo-indisponibilidade.service';
import { MunicipioService } from '../services/municipio.service';
import { TipoVeiculoService } from '../services/tipo-veiculo.service';
import { VeiculoService } from '../services/veiculo.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-veiculos-edit',
	templateUrl: './veiculos-edit.component.html',
	styleUrls: ['./veiculos-edit.component.css'],
	animations: [loadingFade]
})
export class VeiculosEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public veiculo_id = null;

	public formVeiculo: FormGroup;
	public tipo_veiculo_array = [];
	public modelo_veiculo_array = [];
	public marca_veiculo_array = [];
	public especialidade_veiculo_array = [];
	public cor_veiculo_array = [];
	public municipio_array = [];
	
	public motivo_indisponibilidade_array = [];
	public clientes = [];
	public unidades_array;
	public veiculo_status;

	// datepicker
	public data_retorno_dp;

	public exibeSubmit = true;

	constructor(private authSvc: AuthService,
				private clienteSvc: ClienteService,
				private unidadeSvc: UnidadeService,
				private route: ActivatedRoute,
				private corVeiculoSvc: CorVeiculoService,
				private especialidadeVeiculoSvc: EspecialidadeVeiculoService,
				private fb: FormBuilder,
				private marcaVeiculoSvc: MarcaVeiculoService,
				private modeloVeiculoSvc: ModeloVeiculoService,
				private motivoIndispSvc: MotivoIndisponibilidadeService,
				private municipioSvc: MunicipioService,
				private router: Router,
				private tipoVeiculoSvc: TipoVeiculoService,
				private veiculoSvc: VeiculoService) { }

	ngOnInit() {
		this.criaForm();
		this.loading = true;
		this.pegaClientes();

		this.route.params.subscribe( params => {
			if (params.id) {
				this.veiculo_id = params.id;
				// pega dados a partir do id
				this.veiculoSvc.getVeiculo(params.id).then((data: any) => {
					let data_retorno = null
					

					this.preencheForm({
						veiculo_id: data.veiculo_id,
						unidade_id: data.unidade_id,
						cliente_id: data.cliente_id,
						veiculo_numero: data.veiculo_numero,
						veiculo_placa: data.veiculo_placa,
						veiculo_chassi: data.veiculo_chassi,
						veiculo_renavam: data.veiculo_renavam,
						tipo_veiculo_id: data.tipo_veiculo_id,
						especialidade_veiculo_id: data.especialidade_veiculo_id,
						cor_veiculo_id: data.cor_veiculo_id,
						marca_veiculo_id: data.marca_veiculo_id,
						modelo_veiculo_id: data.modelo_veiculo_id,
						veiculo_ano_fabricacao: data.veiculo_ano_fabricacao,
						veiculo_ano_modelo: data.veiculo_ano_modelo,
						veiculo_historico_descricao: data.veiculo_historico_descricao,
						quilometragem: data.quilometragem,
						veiculo_isento: data.veiculo_isento,
						veiculo_checklist: data.veiculo_checklist,
						veiculo_status: data.veiculo_status == 'S' ? true : false,
						unidades:data.unidades
					});

					console.log("[ver]")

					if(params.visualizar == "ver"){
					  this.loading = true;
					  this.formVeiculo.controls['veiculo_numero'].disable();
					  this.formVeiculo.controls['veiculo_placa'].disable();
					  this.formVeiculo.controls['veiculo_chassi'].disable();
					  this.formVeiculo.controls['veiculo_renavam'].disable();
					  this.formVeiculo.controls['tipo_veiculo_id'].disable();
					  this.formVeiculo.controls['especialidade_veiculo_id'].disable();
					  this.formVeiculo.controls['cor_veiculo_id'].disable();
					  this.formVeiculo.controls['marca_veiculo_id'].disable(); 
					  this.formVeiculo.controls['modelo_veiculo_id'].disable();   
					  this.formVeiculo.controls['veiculo_ano_modelo'].disable();
					  this.formVeiculo.controls['cliente_id'].disable();
					  this.formVeiculo.controls['unidades'].disable();
					  this.formVeiculo.controls['veiculo_historico_descricao'].disable();
					  this.formVeiculo.controls['veiculo_isento'].disable();
					  this.formVeiculo.controls['veiculo_checklist'].disable();
					  this.formVeiculo.controls['quilometragem'].disable();
					  this.formVeiculo.controls['veiculo_status'].disable();        
					  this.formVeiculo.controls['veiculo_ano_fabricacao'].disable();        

					  this.exibeSubmit = false;
					  this.loading = false;
					}

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formVeiculo = this.fb.group({
			veiculo_id: null,
			cliente_id: null,
			unidade_id: null,
			veiculo_numero: ['', Validators.required],
			veiculo_placa: ['', Validators.required],
			veiculo_chassi: '',
			veiculo_renavam: '',
			tipo_veiculo_id: [null, Validators.required],
			especialidade_veiculo_id: [null, Validators.required],
			cor_veiculo_id: [null, Validators.required],
			marca_veiculo_id: [null, Validators.required],
			modelo_veiculo_id: [{ value: null, disabled: true }, Validators.required],
			veiculo_ano_fabricacao: ['', Validators.required],
			veiculo_ano_modelo: ['', Validators.required],
			veiculo_historico_descricao: '',
			quilometragem: '',
			veiculo_isento: [null,Validators.required],
			veiculo_checklist: [null,Validators.required],
			veiculo_status: false,
			unidades:null			
		});

		this.pegaTiposVeiculo();
		this.pegaModelosVeiculo();
		this.pegaMarcasVeiculo();
		this.pegaEspecialidadesVeiculo();
		this.pegaCoresVeiculo();
		this.pegaMunicipios();
		this.pegaMotivosIndisp();
		this.pegaUnidades();
	}

	pegaTiposVeiculo() {
		this.tipoVeiculoSvc.getTiposVeiculo('tipo_veiculo_nome').then((data: any[]) => {
			this.tipo_veiculo_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaModelosVeiculo() {
		this.modeloVeiculoSvc.getModelosVeiculo('modelo_veiculo_nome').then((data: any[]) => {
			this.modelo_veiculo_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaMarcasVeiculo() {
		this.marcaVeiculoSvc.getMarcasVeiculoAtivas('marca_veiculo_nome').then((data: any[]) => {
			this.marca_veiculo_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaEspecialidadesVeiculo() {
		this.especialidadeVeiculoSvc.getEspecialidadesVeiculo('especialidade_veiculo_nome').then((data: any[]) => {
			this.especialidade_veiculo_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaCoresVeiculo() {
		this.corVeiculoSvc.getCoresVeiculo('cor_veiculo_nome').then((data: any[]) => {
			this.cor_veiculo_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaMunicipios() {
		this.municipioSvc.getMunicipios('municipio_nome').then((data: any[]) => {
			this.municipio_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaMotivosIndisp() {
		this.motivoIndispSvc.getMotivosIndisponibilidade('motivo_indisponibilidade_nome').then((data: any[]) => {
			this.motivo_indisponibilidade_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}


	pegaClientes(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.clientes = data;
		});
	}

	pegaUnidades(){
		this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.unidades_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formVeiculo.setValue(dados);
		this.verificaModelo();
		this.verificaCliente();
	}



	enviaVeiculo() {
		console.log(this.formVeiculo.value);
		if (this.formVeiculo.valid) {
			this.submitting = true;

			let toSend = this.formVeiculo.value;
			toSend.unidade_id = toSend.unidades[0];
			if (this.veiculo_id === null) { // criar
				//console.log("[criar]", toSend);
				this.veiculoSvc.criaVeiculo(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Veículo cadastrado com sucesso!',
						onClose: () =>{this.router.navigate(['home/veiculos'])}
					});
				}).catch(err => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente.'
					});
				});
			}
			else { // editar
				console.log("edite veiculo = ", toSend)
				this.veiculoSvc.editaVeiculo(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Veículo alterado com sucesso!',
						onClose: () =>{this.router.navigate(['home/veiculos'])}
					});
				}).catch(err => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente.'
					});
				});
			}
		}
		else{
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
			for( let field in this.formVeiculo.controls){
				let campo = this.formVeiculo.get(field);
				campo.markAsTouched();
			}
		}
	}
 
	invalid(nome) {
		let input = this.formVeiculo.get(nome);
		return input.touched && input.invalid;
	}

	verificaModelo() {
		if (this.formVeiculo.get('marca_veiculo_id').value)
			this.formVeiculo.get('modelo_veiculo_id').enable();
		else
			this.formVeiculo.get('modelo_veiculo_id').disable();
	}

	changeModelo() {
		this.verificaModelo();
		this.formVeiculo.get('modelo_veiculo_id').setValue(null);
	}

	verificaCliente() {
		if (this.formVeiculo.get('cliente_id').value)
			this.formVeiculo.get('unidade_id').enable();
		else
			this.formVeiculo.get('unidade_id').disable();
	}

	onChangeCliente(evento){
		this.formVeiculo.controls.unidades.setValue(null);
		this.unidadeSvc.getUnidadesByUsuarioPorCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
			this.unidades_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}
}
